import React, { useState, useEffect } from "react"
import { ChevronsUpDown } from "lucide-react"
import { Button } from "../../../@/components/ui/button"
import {
	Command,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
} from "../../../@/components/ui/command"
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "../../../@/components/ui/popover"
import { cn } from "../../../@/lib/utils"
import { useExchangeRates } from "../hooks/useExchangerateApi"
import { roundToTwoDecimals } from "../CurrencyConverter"

const ReceiveExchangeComponent = ({ data, currency, setCurrency, receive, send, rate, setReceive, setSend }: any) => {
	// console.log(rate, 'received rate');
	const [open, setOpen] = useState(false);
	// const [selectedCurrency, setSelectedCurrency] = useState({ code: "KES", name: "Kenyan Shilling" });
	// const [amount, setAmount] = useState(25);
	// const [searchQuery, setSearchQuery] = useState("");
	// const [filteredCurrencies, setFilteredCurrencies] = useState([]);

	// const { data, isLoading, isError, error } = useExchangeRates(selectedCurrency.code, amount);

	// useEffect(() => {
	// 	if (data && data.currencyList) {
	// 		const filtered = data.currencyList.filter(currency => {
	// 			const codeMatch = currency.code.toLowerCase().includes(searchQuery.toLowerCase());
	// 			const nameMatch = currency.name.toLowerCase().includes(searchQuery.toLowerCase());
	// 			// console.log(`Currency: ${currency.code}, Code Match: ${codeMatch}, Name Match: ${nameMatch}`);
	// 			return codeMatch || nameMatch;
	// 		});
	// 		// console.log("Filtered Currencies:", filtered);
	// 		setFilteredCurrencies(filtered);
	// 	}
	// }, [data, searchQuery]);

	// const handleAmountSent = () => {
	// 	let x = send * rate
	// 	setReceive(x)
	// };

	// set the first values on page load
	useEffect(() => {
		let x = roundToTwoDecimals(send * rate)
		setReceive(x)
	}, []);

	// 2. when currency change update receive
	useEffect(() => {
		let x = roundToTwoDecimals(send * rate)
		setReceive(x)
	}, [currency]);

	// if (isLoading) return <div>Loading...</div>;
	// if (isError) return <div>Error: {error.message}</div>;

	// const { rates } = data || {};

	return (
		<div className="cc-w-full cc-flex">
			<div className="cc-h-14 cc-flex cc-flex-grow">
				<div className="cc-bg-white cc-border-2 cc-border-primary-700 cc-rounded-l-lg cc-h-16 cc-px-3 cc-flex cc-flex-col cc-w-full">
					<label htmlFor="amount" className="cc-block cc-text-sm cc-pt-2 cc-mb-0">You receive:</label>
					{/* <input
						id="amount"
						type="number"
						value={receive}
						onChange={(e) => {
							// 1. set the receive state onchange
							setReceive(roundToTwoDecimals(Number(e.target.value)));
							// then set the send amount
							const x = roundToTwoDecimals(Number(e.target.value) / rate)
							setSend(x)
						}}
						min="1"
						className="cc-w-full cc-rounded-lg cc-border-none cc-bg-white cc-flex-grow cc-border cc-text-sm focus:cc-outline-none focus:cc-ring-0"
					/> */}
					<input
						id="amount"
						type="text"
						value={receive}
						onChange={(e) => {
							const value = e.target.value;

							// Allow only numbers and one decimal point
							if (/^\d*\.?\d*$/.test(value)) {
								console.log(value, 'onchange');

								// Remove leading zeros
								const cleanValue = value.replace(/^0+(?=\d)/, '');

								if (cleanValue === '' || cleanValue === '.') {
									setReceive(cleanValue);
									setSend('');
								} else {
									const numValue = parseFloat(cleanValue);
									if (!isNaN(numValue)) {
										const roundedReceive = roundToTwoDecimals(numValue);
										setReceive(cleanValue); // Keep the un-rounded value in the input

										const roundedSend = roundToTwoDecimals(numValue / rate);
										setSend(roundedSend);
									}
								}
							}
						}}
						className="cc-w-full cc-rounded-lg cc-border-none cc-bg-white cc-flex-grow cc-border cc-text-sm focus:cc-outline-none focus:cc-ring-0 cc-font-bold"
					/>
				</div>
			</div>
			<div className="cc-flex cc-w-36">
				<Popover open={open} onOpenChange={setOpen}>
					<PopoverTrigger asChild>
						<Button
							role="combobox"
							aria-expanded={open}
							className="cc-w-full cc-justify-between cc-h-16 cc-px-5 cc-flex cc-gap-2 cc-items-center cc-border-2 cc-border-primary-700 cc-bg-primary-700 hover:cc-bg-primary-900 cc-rounded-r-lg"
							onClick={() => setOpen(true)}
						>
							{currency ? (
								<div className="cc-flex cc-items-center cc-gap-2">
									<img
										className="cc-h-6 cc-w-6 cc-rounded-xl cc-overflow-hidden"
										src={currency.flag}
										alt={currency.flagAlt}
									/>
									<span>{currency.code === "ZWL" ? "USD" : currency.code}</span>
								</div>
							) : (
								"Select currency..."
							)}
							<ChevronsUpDown className="cc-h-4 cc-w-4 cc-opacity-50" />
						</Button>
					</PopoverTrigger>
					<PopoverContent className="cc-w-full cc-p-0">
						<Command className="cc-flex cc-flex-col cc-p-2">
							<CommandInput
								placeholder="Search currency..."
								className="cc-h-9 cc-border cc-m-2 border"
							/>
							<CommandList>
								<CommandEmpty>Enter Code...</CommandEmpty>
								<CommandGroup>
									{data.currencyList.map((currency) => (
										<CommandItem
											key={currency.code}
											value={currency.name}
											onSelect={() => {
												setCurrency(currency)
												setOpen(false)
											}}
											className="hover:cc-bg-gray-100 cc-cursor-pointer cc-flex cc-justify-between cc-gap-4"
										>
											<div className="cc-flex cc-items-center cc-gap-2">
												<img className={cn(
													"cc-mr-2 cc-h-6 cc-w-6 cc-rounded-xl cc-overflow-hidden",
													currency.code === currency.code ? "cc-border-2" : "cc-border-none"
												)} src={currency.flag} alt={currency.flagAlt} />
												{currency.name === "Zimbabwean Dollar (2009)" ? "Zimbabwe" : currency.name}
											</div>
											{currency.code === "ZWL" ? "USD" : currency.code}
										</CommandItem>
									))}
								</CommandGroup>
							</CommandList>
						</Command>
					</PopoverContent>
				</Popover>
			</div>
		</div>
	)
}

export default ReceiveExchangeComponent
